import type { CmsModel } from 'types/cms';
import { SET_CMS_MODEL } from 'client/constants/actions';

export function setCmsModel(payload: CmsModel) {
	return {
		type: SET_CMS_MODEL,
		payload,
	};
}
